import React, { useEffect } from 'react';
import ProgressBar from '@/components/ProgressBar';

const PageLoading = () => {
  const delay = 1000

  useEffect(() => {
    const timer = setTimeout(() => ProgressBar.start(), delay)

    return () => {
      ProgressBar.done()
      clearTimeout(timer)
    }
  }, [])

  return <></>;
};

export default PageLoading;